/* commit Mutation to change state */
import * as types from './mutation-types';

export default {
  [types.GET_CUT_OFF_TIME_LIST] (state, arr) {
    state.cutOffTimeList = arr;
  },
  setUserInfo (state, payload) {
    state.userInfo = payload;
  },
  setUserInfo (state, payload) {
    state.userInfo = payload;
  },
  setPoiInfo (state, payload) {
    state.poiInfo = payload;
  },
  setPVCheck (state,payload) {
    state.PVCheck = payload;
  },
  setAuthrorize (state, payload) {
    state.authrorizeType = payload;
  },
  setConsumingPriceAvg (state, val) {
    state.consumingPriceAvg = val.memberAnalysisOverview.consumingPriceAvg;
  },
  setFcStatus (state, val) {
    state.fcStatus = val.status;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js